import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SixTomos() {
  const tomos = [{
    num: 'TOMO 1',
    title: 'De la Clínica al Sistema: Planificación del Acompañamiento Postparto',
    badge: 'Organización esencial',
    desc: 'Cómo estructurar tu práctica completa: fases de intervención, secuencia de sesiones y plantillas listas para usar desde el primer día con tu paciente.'
  }, {
    num: 'TOMO 2',
    title: 'Fichero Clínico: 80 Herramientas Listas para la Sesión',
    badge: '80 herramientas listas',
    desc: 'Recursos clínicos completos con instrucciones, objetivos y adaptaciones por perfil de paciente: evaluación, vínculo, lactancia, regulación emocional y detección de señales de alerta.'
  }, {
    num: 'TOMO 3',
    title: 'Evalúa y Acompaña: Sistema de Seguimiento de Pacientes',
    badge: 'Planillas incluidas',
    desc: 'Llevá el registro real del progreso de cada paciente y mostrá resultados concretos a tu equipo, obras sociales o institución.'
  }, {
    num: 'TOMO 4',
    title: 'Sesiones que Conectan: Dinámicas, Recursos y Actividades',
    badge: '40 dinámicas listas',
    desc: 'Diseñá sesiones que contengan, motiven y retengan a tus pacientes semana tras semana.'
  }, {
    num: 'TOMO 5',
    title: 'Profesional Sin Drama: Gestión, Familias e Instituciones',
    badge: 'Plantillas incluidas',
    desc: 'Manejá situaciones difíciles, comunicación con familias e institución como una profesional de la salud perinatal formada.'
  }, {
    num: 'TOMO 6 — ESPECIAL DPP',
    title: 'Depresión Postparto: Guía Clínica Completa para el Profesional de Acompañamiento',
    badge: 'Protocolos incluidos',
    desc: 'Detectás, intervenís y derivás con seguridad aunque no seas psiquiatra: escalas validadas, protocolos de crisis, guiones de abordaje y criterios de derivación.',
    special: true
  }];
  const includes = ['Herramientas listas desde la primera sesión', 'Recursos con objetivo, desarrollo y variantes por perfil de paciente', 'Indicaciones clínicas listas para usar en consulta', 'Variaciones para postparto inmediato, tardío y situaciones de crisis', 'Checklist pre y durante la sesión', 'Planillas de seguimiento de pacientes', 'Adaptaciones para distintos contextos público, privado y domicilio', '100% adaptado a la realidad de la profesional de postparto argentina'];
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-cream relative overflow-hidden" data-id="element-294">
      <div className="max-w-6xl mx-auto" data-id="element-295">
        <div className="text-center mb-8 md:mb-16" data-id="element-296">
          <h2 className="text-3xl md:text-5xl font-bold text-navy mb-2 md:mb-4" data-id="element-297">
            LOS 6 TOMOS
          </h2>
          <p className="text-base md:text-xl text-navy/70 font-serif italic" data-id="element-298">
            Para profesionales de postparto de todos los enfoques y
            especialidades
          </p>
        </div>

        <div className="flex overflow-x-auto pb-6 -mx-4 px-4 md:grid md:grid-cols-2 lg:grid-cols-3 md:overflow-visible md:pb-0 md:mx-0 md:px-0 gap-4 md:gap-6 snap-x snap-mandatory hide-scrollbar mb-8 md:mb-20" data-id="element-299">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} whileHover={{
          y: -5
        }} className={`min-w-[85vw] md:min-w-0 snap-center rounded-2xl md:rounded-3xl p-6 md:p-8 border ${tomo.special ? 'bg-navy text-white border-navy shadow-xl shadow-navy/20' : 'bg-white text-navy border-navy/10 shadow-soft'} flex flex-col h-full`} data-id="element-300">
              <div className="mb-4 md:mb-6" data-id="element-301">
                <span className={`inline-block px-2 py-1 md:px-3 md:py-1 text-[10px] md:text-xs font-bold rounded-full mb-3 md:mb-4 ${tomo.special ? 'bg-terracotta text-white' : 'bg-gold/20 text-gold-700'}`} data-id="element-302">
                  {tomo.num}
                </span>
                <h3 className={`text-lg md:text-xl font-bold leading-snug mb-2 md:mb-3 ${tomo.special ? 'text-white' : 'text-navy'}`} data-id="element-303">
                  {tomo.title}
                </h3>
                <div className={`inline-flex items-center gap-1.5 text-xs md:text-sm font-medium ${tomo.special ? 'text-gold' : 'text-sage-600'}`} data-id="element-304">
                  <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4" data-id="element-305" />
                  {tomo.badge}
                </div>
              </div>
              <p className={`mt-auto text-xs md:text-sm leading-relaxed ${tomo.special ? 'text-white/80' : 'text-navy/70'}`} data-id="element-306">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-soft border border-navy/5 max-w-4xl mx-auto" data-id="element-307">
          <h3 className="text-xl md:text-2xl font-bold text-navy mb-6 md:mb-8 text-center" data-id="element-308">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-y-3 md:gap-y-4 gap-x-8" data-id="element-309">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-310">
                <div className="mt-0.5 md:mt-1 bg-sage/20 rounded-full p-0.5 flex-shrink-0" data-id="element-311">
                  <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-sage-600" data-id="element-312" />
                </div>
                <span className="text-navy/80 text-xs md:text-sm leading-relaxed" data-id="element-313">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `
    }} data-id="element-314" />
    </section>;
}